// implement your own methods in here, if your data is coming from A rest API

import * as Salary from "./salary.js";
import * as Stock from "./stock.js";
import * as Notification from "./notification.js";
import * as InventoryProfit from "./inventoryProfit.js";
import * as FormData from "./formData.js";
import * as PurchaseDashboard from "./purchaseDashboard.js";
import * as WavePicking from "./wavePicking";
import * as Machine from "./machine.js";
import * as Setting from "./setting.js";
import * as GoodsInspection from "./goodsInspection.js";

export default {
  // Salary
  getProcessItemPriceTree: Salary.getProcessItemPriceTree,
  getPositionStaffingList: Salary.getPositionStaffingList,
  getPositionOperatingLog: Salary.getPositionOperatingLog,
  getPositionOperatingDetail: Salary.getPositionOperatingDetail,
  setPieceDisabledPeriod: Salary.setPieceDisabledPeriod,
  deletePosition: Salary.deletePosition,
  getSalaryAccountingSummary: Salary.getSalaryAccountingSummary,
  getSalaryAccountingSummaryDetail: Salary.getSalaryAccountingSummaryDetail,
  getPositionList: Salary.getPositionList,
  addPosition: Salary.addPosition,
  getPositionListForRecheck: Salary.getPositionListForRecheck,
  recalculateSalary: Salary.recalculateSalary,
  changeProcessStatus: Salary.changeProcessStatus,
  updateProcessPrices: Salary.updateProcessPrices,
  uploadPositionStaffingList: Salary.uploadPositionStaffingList,

  // Stock
  getOutboundOrderList: Stock.getOutboundOrderList,
  getShippingOrderList: Stock.getShippingOrderList,
  getShippingLogList: Stock.getShippingLogList,
  getAvailableProducts: Stock.getAvailableProducts,
  getPickingOrderList: Stock.getPickingOrderList,
  updateShippingOrderInfo: Stock.updateShippingOrderInfo,
  getOutboundOrderDetail: Stock.getOutboundOrderDetail,
  getShippingOrderDetail: Stock.getShippingOrderDetail,
  getPickingOrderDetail: Stock.getPickingOrderDetail,
  searchSupplyName: Stock.searchSupplyName,
  createShippingOrder: Stock.createShippingOrder,
  searchWarehouse: Stock.searchWarehouse,
  mobilizeWarehouse: Stock.mobilizeWarehouse,
  getWarehouseWorkers: Stock.getWarehouseWorkers,
  getManagerList: Stock.getManagerList,
  getManagerInfo: Stock.getManagerInfo,
  createWarehouseWorker: Stock.createWarehouseWorker,
  createWarehouse: Stock.createWarehouse,
  getSupplyName: Stock.getSupplyName,
  getReportList: Stock.getReportList,
  getPreStockReportDetial: Stock.getPreStockReportDetial,

  // Notification
  getNotificationList: Notification.getNotificationList,
  getNotificationDetail: Notification.getNotificationDetail,
  getReadList: Notification.getReadList,
  createNotification: Notification.createNotification,
  getNotificationDropdownList: Notification.getNotificationDropdownList,
  // InventoryProfit
  exportBarCode: InventoryProfit.exportBarCode,

  //    formData 表单字段请求
  exportStockSource: FormData.exportStockSource,
  exportPurchaseGroup: FormData.exportPurchaseGroup,
  // PurchaseDashboard
  getDepartmentBulletin: PurchaseDashboard.getDepartmentBulletin,
  getIterationBulletin: PurchaseDashboard.getIterationBulletin,
  getPurchaseOweInfo: PurchaseDashboard.getPurchaseOweInfo,
  getPurchaseSearchCondition: PurchaseDashboard.getPurchaseSearchCondition,
  getPackageInfo: PurchaseDashboard.getPackageInfo,
  getWarehouseUnpaid: PurchaseDashboard.getWarehouseUnpaid,
  getNoDataGoods: PurchaseDashboard.getNoDataGoods,
  getOptionsByCityAndType: PurchaseDashboard.getOptionsByCityAndType,
  getReachInfo: PurchaseDashboard.getReachInfo,
  getBillingInfo: PurchaseDashboard.getBillingInfo,

  // WavePicking
  setWarningNotify: WavePicking.setWarningNotify,

  // Machine
  switchPackage: Machine.switchPackage,

  //Setting
  qualityRuleSettingGet: Setting.qualityRuleSettingGet,
  qualityRuleSettingSave: Setting.qualityRuleSettingSave,
  getCheckData: GoodsInspection.getCheckData,
  check: GoodsInspection.check,
  finishCheck: GoodsInspection.finishCheck,
  exitCheck: GoodsInspection.exitCheck,
  getPickingInfo: GoodsInspection.getPickingInfo,
};



// WEBPACK FOOTER //
// ./src/api/index.js